import { HttpClient } from "../HttpClient";

/**
 * Get Contents Claim Status List
 */
export const GetContentsClaimStatusList = async (userId = null, isImpersonation = false) => {
  try {
    // Step 1: Fetch the user's assigned dashboard dynamically
    const { data: user } = await HttpClient.get(`api/users/${userId}`);
    const assignedDashboard = user.assignedDashboard;

    // Step 2: Use it when calling ClaimStatusList
    const { data } = await HttpClient.get("api/contents/ClaimStatusList", {
      params: {
        assignedDashboard,
        ...(userId && { userId }),
        isImpersonation,
      },
    });

    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

// import { HttpClient } from "../HttpClient";
// /**
//  * * Get Contents Claim Status List
//  */
// export const GetContentsClaimStatusList = async () => {
//   try {
//     const { data } = await HttpClient.get("api/contents/ClaimStatusList");
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
